import { useMemo } from "react";
import type { HomeResponse } from "../../shared/home";
import type { ToolMeta } from "../../shared/tools";
import { webTools } from "../../tools/web";
import { useCompany } from "./company";
import { useSm8Query } from "./queries";

/**
 * What tools put on Home (shared/home.ts): its Needs attention, and each section's count in the sidebar (the same request).
 * Refetched when any tool's synced data or its own data changes (and when the tab comes back into view).
 */
export function useHome() {
    const company = useCompany();
    const tools = useMemo(() => company.tools.map((id) => webTools[id]?.meta).filter((m): m is ToolMeta => m !== undefined), [company.tools]);
    const objects = useMemo(() => [...new Set(tools.flatMap((t) => t.datasets ?? []))], [tools]);
    return useSm8Query<HomeResponse>({ companyId: company.id, objects, key: ["home"], path: "/home", alsoOn: tools.map((t) => t.id) });
}
